exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Body-module__wrapper___2WcCU{display:grid;gap:1.5rem}@media screen and (min-width:768px){.Body-module__wrapper___2WcCU{grid-template-columns:.6fr .4fr;gap:6rem}}.Body-module__wrapper___2WcCU .Body-module__description-area___NcNcj{display:grid;gap:1rem;align-content:start;justify-content:start;justify-items:start}.Body-module__wrapper___2WcCU .Body-module__description-area___NcNcj *{justify-self:start!important}.Body-module__wrapper___2WcCU .Body-module__labels___26Inc{display:grid;gap:1rem}", ""]);

// exports
exports.locals = {
	"wrapper": "Body-module__wrapper___2WcCU",
	"description-area": "Body-module__description-area___NcNcj",
	"labels": "Body-module__labels___26Inc"
};